export default __webpack_public_path__ + "static/jupyter-ef6f857b9e118badc3a550e3f11ddc93.png";